// import API from '@/api'

const state = {
  publishedListMoreParams: {
    searchContent: undefined,
    platformCode: '',
    storeIds: []
  }, // 搜索条件存储
  MTProductDetail: null, // 移动端刊登列表详情
  MTBatchPublishedListSpu: [], // 移动端批量刊登列表
  MTBatchSpuCountryDTOList: [] // 移动端批量刊登列表
}
const mutations = {
  set(state, object) {
    Object.assign(state, object)
  }
}
/**
this.$store.dispatch('published/getAddressList').then(result => {
  console.log(result)
})
 */
const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
